import React from 'react'
import PrevIcon from "../../assets/images/prevIcon.svg"

const PrevButton = () => {
  return (
    <div style={{
        background: "#444649",
        width:"20px",
        height:"20px",
        borderRadius:"6px",
        display:"flex",
        alignItems:"center",
        justifyContent:"center"


    }}>
        <img src={PrevIcon} alt='prev' width="7px"/>
    </div>
  )
}

export default PrevButton